var React = require('react');

function FontSize (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("text",{"fill":"#2F73A7","fontFamily":"WorkSans-Regular, Work Sans","key":0},[React.createElement("tspan",{"x":"0","y":"18","fontSize":"14","key":0},"T"),React.createElement("tspan",{"x":"5.5","y":"18","fontSize":"25","key":1},"T")]),React.createElement("text",{"fill":"#0D3B5E","fontFamily":"Arial","fontSize":"18","x":"20","y":"14","key":1},"↕")]));
}

FontSize.defaultProps = {"width":"31","height":"18"};

module.exports = FontSize;

FontSize.default = FontSize;
